module.exports = __webpack_public_path__ + "octo-surfer-200.84367af1486fcb9a1cbc22115b07a42f.hashedasset.png";